import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
import FormDropdown from "./FormDropdown";

const ModalFormDropdown = props => <FormDropdown {...props} popoverClassName="modalDropdown" />;

ModalFormDropdown.propTypes = {
  options: PropTypeShapes.listOptionArrayOrList.isRequired,
  openOnFocus: PropTypes.bool,
  allowSearch: PropTypes.bool,
  allowParentSelection: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  centerLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  onChange: PropTypes.func,
  popoverClassName: PropTypes.string,
  title: PropTypes.string,
  backText: PropTypes.string,
  showDescription: PropTypes.bool,
  useParentWidth: PropTypes.bool,
  style: PropTypes.object
};

export default ModalFormDropdown;
